export default "__VITE_ASSET__CStH4Hw2__"